import { useEffect, useState } from "react";

/** Minutos desde meia-noite; atualiza a cada 30s para o ponteiro do calendário. */
export function useNowMinutes(): number {
  const read = () => {
    const n = new Date();
    return n.getHours() * 60 + n.getMinutes() + n.getSeconds() / 60;
  };
  const [minutes, setMinutes] = useState(read);

  useEffect(() => {
    const tick = () => setMinutes(read());
    tick();
    const id = setInterval(tick, 30_000);
    return () => clearInterval(id);
  }, []);

  return minutes;
}
